import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import connect from "react-redux/es/connect/connect";
import Grid from "@material-ui/core/Grid";
import FiltersSection from "../../Filters/FiltersSection";
import {Typography} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import {getAutoclaves, getAutoclavesUtilizacaoData} from "../../../actions/autoclaveActions";
import AutoclaveUtilizacao from "./AutoclaveUtilizacao";
import {useSelector} from "react-redux";

const useStyles = makeStyles(theme => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
    progress: {
        margin: theme.spacing(1) * 2,
    },

}));




const AutoclaveProducao = ({
                              isOpen,
                               autoclaves,
                               autoclaveUtilizacaoData,
                               getAutoclaves,
                               getAutoclavesUtilizacaoData,
                               filter

}) => {


  const classes = useStyles();
 // const [addNewRecord, setaddNewRecord] = React.useState(isAddNewRecord ? isAddNewRecord : false);
  const [isLoading, setisLoading] = React.useState(true);
 // const [ciclo, setCiclo] =  React.useState(cicloDetalhes);
    const loading = useSelector(state => state.autoclaves.isFetchingAutoclaveUtilizacaoData);


  useEffect( () => {
    //setOpen(isOpen);
  }, [ isOpen ]);

  useEffect(() => {
     console.log("useEffect 0,0")
      getAutoclaves()
      getAutoclavesUtilizacaoData()
  }, [0, 0]);

    const onFilterClick = () => {
        getAutoclaves()
        getAutoclavesUtilizacaoData()
    }


    // useEffect(() => {
    //     console.log("useEffect filter")
    //     getAutoclaves()
    //     getAutoclavesUtilizacaoData()
    // }, [filter]);

   const renderLoadingScreen = () => {
        // const { classes } = props;
        return (
            <React.Fragment>
                {/*<div align="center">*/}
                {/*    <Typography>loadingDataScreen</Typography>*/}
                {/*    <CircularProgress className={classes.progress} />*/}
                {/*</div>*/}
            </React.Fragment>
        )
    }

    const renderContent = () => {
        // const { classes } = props;

        return (
            <React.Fragment>
                <div align="center">
                    <CircularProgress className={classes.progress} />
                    { autoclaves.map( (a,ix) => {
                        const xud = autoclaveUtilizacaoData.filter( (r) => r.autoclaveId === a.id );
                       // if (a.codigo === 2) {
                            return <AutoclaveUtilizacao key={ix} autoclave={a} dados={xud}/>
                       // } else { return <React.Fragment/> }
                    }  ) }

                </div>
            </React.Fragment>
        )
    }



  // console.log("fullScreenDialog.selectedrow",selectedRow);

  // console.log("LAOSLAOSLAOSLAOSLAOS", autoclaveUtilizacaoData)

    console.log("filter", filter)

  return (
      <React.Fragment>
          <Grid container direction="column" className={classes.dashboardSection}>
              <Grid item xs={12}>
                  {/*onButtonClick={this.props.getRaspaCycleHourUsageStatistics}*/}
                  <FiltersSection showPeriod={true} showBeforePeriod={false}
                                  showBenchPeriod={false} onFilterClick={onFilterClick} loading={loading}  />
              </Grid>
          </Grid>
          <Grid item  xs={12} sm={12} lg={12} xl={12}>
              <Typography variant="h4" align="center" className={classes.sectionTitle}>
                  AUTOCLAVE - PRODUÇÃO
              </Typography>
          </Grid>
          { loading ? renderLoadingScreen() : renderContent() }

      </React.Fragment>
  );
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.auth.id !== null,
      autoclaves: state.autoclaves.Autoclaves,
      loading : state.autoclaves.isFetchingAutoclaveUtilizacaoData,
      autoclaveUtilizacaoData : state.autoclaves.utilizacaoData,
      filter : state.filter

  }
}

export default connect(mapStateToProps, {
    getAutoclavesUtilizacaoData,
    getAutoclaves
})(AutoclaveProducao)
